export default "__VITE_ASSET__DhTIPCS6__"